import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBendCreator = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1390_20209",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_1390_20209)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17 21.5C15.7513 21.5 14.6892 21.0622 13.8135 20.1865C12.9378 19.3108 12.5 18.2487 12.5 17C12.5 15.7513 12.9378 14.6892 13.8135 13.8135C14.6892 12.9378 15.7513 12.5 17 12.5C18.2487 12.5 19.3108 12.9378 20.1865 13.8135C21.0622 14.6892 21.5 15.7513 21.5 17C21.5 18.2487 21.0622 19.3108 20.1865 20.1865C19.3108 21.0622 18.2487 21.5 17 21.5ZM16.5577 19.75H17.4423V17.4422H19.75V16.5577H17.4423V14.25H16.5577V16.5577H14.25V17.4422H16.5577V19.75Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.4414 3.01473C15.6305 2.97943 15.8155 3.00801 15.9961 3.10164L19.8389 4.88289C20.0002 4.96355 20.1151 5.08043 20.1836 5.23348C20.2522 5.38679 20.2512 5.53937 20.1807 5.69051C20.0999 5.85191 19.983 5.95554 19.8301 6.00106C19.6769 6.04656 19.5244 6.03347 19.373 5.96297L15.6768 4.25594L13.3076 6.45613V7.85555L15.6768 10.0059L19.373 8.29793C19.5244 8.22745 19.6796 8.21797 19.8379 8.26863C19.996 8.31935 20.1102 8.42036 20.1807 8.57137C20.2611 8.73268 20.2649 8.88723 20.1914 9.03524C20.1178 9.18318 20.0003 9.29816 19.8389 9.37899L15.9961 11.1905C15.8155 11.2841 15.6305 11.311 15.4414 11.2725C15.2525 11.2341 15.086 11.1469 14.9424 11.0098L13.1846 9.38973V9.52449C13.1231 9.62449 13.0357 9.71329 12.9229 9.79012C12.81 9.86709 12.6883 9.90535 12.5576 9.90535C12.345 9.90532 12.167 9.83389 12.0234 9.69051C11.8799 9.54701 11.8076 9.36819 11.8076 9.15535V7.90535H8.37695C8.32695 8.08352 8.25807 8.25688 8.1709 8.42488C8.08358 8.59268 7.98047 8.74699 7.86133 8.8868L11.6113 15.8448C11.5375 16.2142 11.5 16.5993 11.5 17.0001C11.5 18.2666 11.8693 19.3756 12.6064 20.3282H4V18.0206H7.06152L4.49219 9.61336C4.04869 9.38269 3.68875 9.04795 3.41309 8.60945C3.13749 8.171 3 7.68595 3 7.15535C3.00008 6.39266 3.26748 5.74334 3.80273 5.20809C4.33789 4.67295 4.98718 4.40535 5.75 4.40535C6.38063 4.40535 6.93237 4.59309 7.40527 4.96785C7.87819 5.34279 8.20243 5.82216 8.37695 6.40535H11.8076V5.15535C11.8077 4.94266 11.88 4.76477 12.0234 4.62117C12.1671 4.47777 12.3449 4.40538 12.5576 4.40535C12.6883 4.40535 12.81 4.43927 12.9229 4.50594C13.0356 4.57258 13.1231 4.66578 13.1846 4.78621V4.92098L14.9424 3.28231C15.086 3.13879 15.2525 3.04987 15.4414 3.01473ZM6.64648 9.80965C6.59515 9.84165 6.51365 9.8682 6.40332 9.8907C6.29329 9.91315 6.19997 9.91817 6.12305 9.90535L8.61133 18.0206H11.0615L6.64648 9.80965ZM5.75 5.90535C5.40252 5.90535 5.10708 6.0268 4.86426 6.26961C4.62133 6.51253 4.50008 6.80799 4.5 7.15535C4.5 7.50261 4.62137 7.79813 4.86426 8.0411C5.10709 8.2841 5.4025 8.40535 5.75 8.40535C6.0975 8.40535 6.39291 8.2841 6.63574 8.0411C6.87863 7.79813 7 7.50261 7 7.15535C6.99992 6.80799 6.87867 6.51253 6.63574 6.26961C6.39292 6.0268 6.09748 5.90535 5.75 5.90535Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5 18.0206V20.3282H16.459V18.0206H16.5Z",
				fill: "currentColor"
			})
		]
	})]
});
export default SvgBendCreator;
